






























































































































































import { Component, Prop, Ref, Watch } from "vue-property-decorator";
import Vue from "vue";
import { getModule } from "vuex-module-decorators";
import Users from "@/store/modules/Users";
import Comments, { ResourceType } from "@/store/modules/Comments";
import Viewpoints from "@/store/modules/Viewpoints";
import { Observable, ZenObservable } from "zen-observable-ts";
import { API, graphqlOperation } from "aws-amplify";
import { onCreateThreadComment, onDeleteThreadComment, onUpdateThreadComment } from "@/graphql/subscriptions";
import Colors from "@/utils/Colors";
import { UpdateCommentInput } from "@/API";
import _ from "lodash";
import TagMenu from "@/components/comments/TagMenu.vue" 
import CommentEditor from "@/components/comments/CommentEditor.vue"
import WorkspaceOptions from "@/store/modules/WorkspaceOptions";

const commentsModule = getModule(Comments)
const viewpointsModule = getModule(Viewpoints)
const usersModule = getModule(Users);
const workspaceOptions = getModule(WorkspaceOptions)
@Component({
    components: {TagMenu, CommentEditor}
})
export default class CommentThreadDisplay extends Vue {
    private colors = Colors.COLORS

    @Prop()
    name!: string

    @Prop({required: true})
    decisionId!: string;

    @Prop()
    allTags!: string[]

    @Prop({required: true})
    resource!: {
        id: string | 'CONTENT',
        name?: string,
        type: ResourceType
    };

    @Prop({required: true})
    secondaryResource!: {
        id: string | "WEIGHT",
        name?: string,
        type: ResourceType
    };

    @Prop({required: true})
    tertiaryResource: {
        id: string,
        name?: string,
        type: ResourceType
    }

    @Prop()
    viewpointComments: any[]

    @Prop({default: false, type: Boolean})
    timelineView: boolean

    private comments: any[] = [];

    private newComment = '';
    private replyingToCommentId: string | undefined;
    private loading = true;
    private submittingComment = false;
    private deletingComment = false;
    private isError = false;
    private tags = ['concerns', 'suggestions', 'strengths', 'questions', 'weaknesses']
    private selected = []
    private newTag = "";
    private showEdit = "";
    private editContent = "";
    private selectedTags = []
    private clearInc = 0
    private hoverTitle = "";
    @Ref()
    private commentForm: HTMLFormElement;

    get userProfiles() {
        return usersModule.userProfiles;
    }

    get commentVertical(){
        return workspaceOptions.commentVertical;
    }

    get commentBottomHeight(){
        return workspaceOptions.commentBottomHeight;
    }

    get currentUser() {
        return usersModule.currentUserProfile;
    }

    get userId(): string {
        if (this.currentUser) {
            return this.currentUser.userId;
        }
        return '';
    }

    get commentThreads() {
        return commentsModule.commentThreads;
    }

    get commentThread() {
        return this.commentThreads[Comments.generateId(this.resource.id, this.secondaryResource.id, this.tertiaryResource.id)];
    }

    get generatedCommentId() {
        return Comments.generateId(this.resource.id, this.secondaryResource.id, this.tertiaryResource.id);
    }

    get commentThreadId() {
        return this.commentThread ? this.commentThread.id : null;
    }

    get orderedComments() {
        return this.comments.sort((a, b) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime())
    }

    private getDisplayName(userId: string) {
        let user;
        if (userId === this.userId) {
            return 'You'
            // user = this.currentUser;
        } else {
            user = this.userProfiles[userId]
        }

        if (!user) {
            return null;
        }

        if (!user.first) {
            return user.email.split('@')[0];
        }

        let name = '';
        if (user.first) {
            name = name + user.first;
        }
        if (user.last) {
            name = name + ' ' + user.last;
        }
        return name;
    }

    private getUserAvatarName(userId: string) {
        let name = this.getDisplayName(userId)
        if (name) {
            return name.substring(0, 1);
        }
    }

    private getColor(userId: string) {
        if (userId === this.userId) {
            return 'indigo'
        }
        return this.colors[Object.keys(this.userProfiles).indexOf(userId)]

    }

    async addComment(viewpointId) {
        if (this.newComment.trim().length == 0) {
            return;
        }

        if(!this.userId) {
            this.isError = true;
            setTimeout(() => {
                this.isError = false;
            }, 3000);
            return;
        }

        this.submittingComment = true;
        let result = {
            comment: this.newComment,
            decisionId: this.decisionId,
            resourceId: viewpointId != null ? viewpointId : this.resource.id,
            secondaryResourceId: this.secondaryResource.id,
            tertiaryResourceId: this.tertiaryResource.id,
            threadId: this.commentThread ? this.commentThread.id : '',
            tags: this.selectedTags && this.selectedTags.length > 0 ? this.selectedTags: null

        }
        this.$emit("new", result)
        // this.allComments[viewpointId].splice(0, 0, result);
        this.selectedTags = []
        this.clearInc += 1;
        this.showEdit = "";
        this.newComment = '';
        this.submittingComment = false;

    }

    async deleteComment(commentId: string) {
        this.deletingComment = true;
        this.$emit('delete', {commentId: commentId, resource: this.resource.id})

        this.deletingComment = false;
    }

    async updateComment(commentId: string) {
        if (this.editContent.trim().length == 0) {
            return;
        }

        if(!this.userId) {
            this.isError = true;
            setTimeout(() => {
                this.isError = false;
            }, 3000);
            return;
        }

        this.submittingComment = true;
        let payload = {
            comment: this.editContent,
            decisionId: this.decisionId,
            id: commentId,
            threadId: this.commentThread ? this.commentThread.id : '',
            tags: this.selectedTags && this.selectedTags.length > 0 ? this.selectedTags: null
        }

        this.$emit("edit", {comment: payload, resource: this.resource.id})
      
        this.selectedTags = []
        this.clearInc += 1;
        this.editContent = '';
        this.showEdit = '';
        this.submittingComment = false;
        
    }


    private formatDate(date: Date) {
        let now = new Date();

        let time = date.toLocaleTimeString([], {hour: '2-digit', minute: '2-digit'});

        let diff = now.getTime() - date.getTime();
        if (diff <= 86400000 && date.getDate() == now.getDate()) {
            return time + ' Today'
        }
        if (diff < (now.getHours() * 3600000) + 86400000) {
            return time + ' Yesterday'
        }
        return date.toDateString()
    }


    private changeSelectedTags(tags) {
         if(tags === null) {
            this.selectedTags = []
        }
        else
            this.selectedTags = tags
    }


}
